<template>
  <a-layout :style="{ height: '100%'}">
    <a-layout-header class="header">
      <div class="logo" />
      <a-menu
          v-model:selectedKeys="topSelected"
          theme="dark"
          mode="horizontal"
          :style="{ lineHeight: '64px' }"
          @click="topMenuClick"
      >
        <a-menu-item v-for="item in menuList" :key="item.key">
          {{item.title}}
        </a-menu-item>
      </a-menu>
    </a-layout-header>
    <a-layout :style="{ height: '100%'}">
      <a-layout-sider id="left-menu" width="200" theme="light" collapsible>
        <a-menu
            v-model:selectedKeys="leftSelected"
            v-model:openKeys="openKeys"
            theme="light"
            mode="inline"
            :style="{ height: '100%', borderRight: 10 }"
            @click="handleClick"
        >
          <template v-for="item in leftMenuList" :key="item.key">
            <template v-if="null != item.icon">
              <a-menu-item :key="item.key" :path="item.path">
                {{item.title}}
              </a-menu-item>
            </template>
            <template v-else>
              <a-menu-item :key="item.key" :path="item.path">
                {{item.title}}
              </a-menu-item>
            </template>
          </template>
        </a-menu>
      </a-layout-sider>
      <a-layout>
        <a-layout-content id="route-view-layout">
          <router-view id="route-view"></router-view>
        </a-layout-content>

        <a-layout style="width: 100%; height: 40px; display: flex; z-index: 999; line-height: 39px; zoom: 1;">
          <p style=" height: 40px; visibility: visible; text-align: center; text-decoration: none; -webkit-tap-highlight-color:rgba(0,0,0,0);">
            <span style="color: #666; margin-right: 20px;">© 2009-2024 28tool.cn</span>
            <a style="color: #666; " href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备2023038847号</a>
          </p>
        </a-layout>
      </a-layout>
    </a-layout>
  </a-layout>
</template>

<script>
import { defineComponent, ref } from 'vue';
import router from '@/router/index';

const menuList = [
  {
    "key": "tools",
    "title": "工具",
    "children": [
      {
        "key": "Base64Util",
        "title": "Base64工具",
        "path": "/Base64Util",
      },
      {
        "key": "JsonFormat",
        "title": "JSON工具",
        "path": "/JsonFormat",
      },
      {
        "key": "JWTUtil",
        "title": "JWT工具",
        "path": "/JWTUtil",
      },
      {
        "key": "URLTranscodeUtil",
        "title": "URL转码",
        "path": "/URLTranscodeUtil",
      },
      {
        "key": "MD5Util",
        "title": "MD5工具",
        "path": "/MD5Util",
      },
      {
        "key": "QRCodeUtil",
        "title": "二维码工具",
        "path": "/QRCodeUtil",
      },
      {
        "key": "CompareUtil",
        "title": "文本比对",
        "path": "/CompareUtil",
      }
    ]
  },
  {
    "key": "help",
    "title": "帮助",
    "children": [
      {
        "key": "read",
        "title": "简介",
        "path": "/PubDescription",
      }
    ]
  }
]

export default defineComponent({
  name: "MainPage",
  components: {
  },
  data() {
    return {
      // leftMenuList: [],
    }
  },
  methods: {
    topMenuClick(item) {
      let children = [];
      for (let i = 0; i < this.menuList.length; i++) {
        let leftMenuListElement = this.menuList[i];
        if (leftMenuListElement.key === item.key) {
          children = leftMenuListElement.children;
          break;
        }
      }
      this.leftMenuList = children;
      this.leftSelected[0] = children[0].key
      router.push({
        path: children[0].path,
      })
    }
  },
  setup() {
    const handleClick = (item) => {
      router.push({
        path: item.item.path,
      })
    }
    const topMenuSelected = menuList[0].key  // 顶部菜单选中第一个
    const leftMenu = menuList[0].children // 左侧菜单列表
    const leftMenuSelected = menuList[0].children[0].key // 左侧菜单选中第一个

    router.push({
      path: leftMenu[0].path,
    })
    return {
      leftMenuList: ref(leftMenu),
      topSelected: ref([topMenuSelected]),
      leftSelected: ref([leftMenuSelected]),
      collapsed: ref(false),
      openKeys: ref([]),
      handleClick,
      menuList,
    };
  },

});
</script>

<style scoped>
/*#components-layout-demo-top-side-2 .logo {*/
/*  float: left;*/
/*  width: 120px;*/
/*  height: 31px;*/
/*  margin: 16px 24px 16px 0;*/
/*  background: rgba(255, 255, 255, 0.3);*/
/*}*/

/*.ant-row-rtl #components-layout-demo-top-side-2 .logo {*/
/*  float: right;*/
/*  margin: 16px 0 16px 24px;*/
/*}*/

#route-view-layout {
  width: 100%;
  height: 99%;
  overflow: hidden;
  overflow-y: auto;
  background: #fff;
  padding: 0;
  margin: 0;
}

#route-view {
  /*width: 100%;*/
  /*height: 100%;*/
}

</style>